'use client';

import { attendantInterviewTitle } from '@bells/i18n';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@bells/ui/components/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@bells/ui/components/collapsible';
import { MinusIcon, PlusIcon } from 'lucide-react';

export const GirlInterview = ({
  data,
}: {
  data: AttendantSearchSingleResponse;
}) => {
  return (
    data.interviews &&
    data.interviews.length > 0 && (
      <Card className='w-full border-0 bg-transparent shadow-none lg:border lg:shadow-sm'>
        <CardHeader className='px-0 lg:p-6'>
          <CardTitle>{attendantInterviewTitle()}</CardTitle>
        </CardHeader>
        <CardContent className='w-full space-y-4 px-0 lg:p-6'>
          {data.interviews.map((df, index) => {
            return (
              <Collapsible
                className='group'
                defaultOpen={index == 0}
                key={`question-${index}`}
              >
                <CollapsibleTrigger className='flex w-full cursor-pointer items-center justify-between gap-2 rounded-none border-b bg-card px-0 py-3 text-left'>
                  <h3 className='text-base font-bold'>
                    {df.question.question}
                  </h3>
                  <PlusIcon className='h-5 w-5 text-muted-foreground group-data-[state=open]:hidden' />
                  <MinusIcon className='h-5 w-5 text-muted-foreground group-data-[state=closed]:hidden' />
                </CollapsibleTrigger>
                <CollapsibleContent className='rounded-md bg-background p-4 px-0 shadow-sm'>
                  <p className='text-muted-foreground'>{df.answer}</p>
                </CollapsibleContent>
              </Collapsible>
            );
          })}
        </CardContent>
      </Card>
    )
  );
};
